export default __webpack_public_path__ + "static/title-singtel-82de36edb9d8f24cf57063a39c81a24c.svg";